import { get } from 'lodash';
import { push } from '../services/router-utils';

import { ERROR_PAGES } from '@wix/communities-blog-client-common/dist/src/constants/errors';

const errorHandlerMiddleware = store => next => action => {
  const errorPage = getErrorPage(action);
  if (errorPage) {
    store.dispatch(push(`/${errorPage}`));
  }
  return next(action);
};

const shouldHandle = action => get(action, 'type', '').endsWith('FETCH_FAILURE');

function getErrorPage(action) {
  if (!shouldHandle(action)) {
    return undefined;
  }
  const status = get(action, 'payload.error.status');
  return ERROR_PAGES.includes(status) ? status : undefined;
}

export default errorHandlerMiddleware;
